<div class="TotemWidgetActivities TotemWidgetHScroll" role="region" [attr.aria-label]="'totem-a11y.activities-list' | locTranslate">
    <div #activitiesList class="TotemWidgetHScroll-List TotemWidgetActivities-List">
        @for (day of activityList; track day; let dayIndex = $index) {
            <div>
                <div class="TotemWidgetActivities-List-Item card">
                    <div class="card-body">
                        <div class="TotemWidgetActivities-List-Item-Header border-bottom d-flex justify-content-between">
                            <h5 class="text-primary m-0" [id]="'activities-day-' + id + '-' + dayIndex">{{ getRelativeDate(day.date) }}</h5>
                            <div class="text-muted">
                                <i class="fa-regular fa-calendar me-2" aria-hidden="true"></i>
                                <span>{{ day.date | locFormat:'date'}}</span>
                            </div>
                        </div>
                        <div class="TotemWidgetActivities-List-Item-Content" role="list" [attr.aria-labelledby]="'activities-day-' + id + '-' + dayIndex">
                            @for (activity of day.activities; track activity; let i = $index) {
                                <div class="d-flex {{i > 0 ? 'mt-4' : ''}}" role="listitem">
                                    @if (getActivityTime(activity); as activityTime) {
                                        <div class="TotemWidgetActivities-List-Item-Content-Time text-muted me-3">
                                            <div>{{ activityTime | locFormat:'time'}}</div>
                                        </div>
                                    }
                                    <div class="TotemWidgetActivities-List-Item-Content-Text">
                                        <h5 class="mb-2">{{activity.title}}</h5>
                                        @if (activity.description) {
                                            <div class="text-muted">{{activity.description}}</div>
                                        }
                                        @if (activity.duration) {
                                            <div class="text-muted">{{ 'totem-widget-activities.duration' | locTranslate:'duration':formatDuration(activity.duration) }}</div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
